// Interpolacion entre reportes para un vehiculo sin recorrido conocido
// (PP-51, mapa de la flota del proveedor). La torre mueve cada vehiculo por
// dead reckoning sobre la polilinea de su viaje (apps/tower/src/logic/fleet.ts);
// el portal no recibe paradas ni recorridos (ADR-025 §3), asi que desliza el
// marcador en linea recta desde donde se ve hasta el reporte nuevo, en el
// tiempo que tarda en llegar el siguiente. Nunca extrapola: sin reporte nuevo
// el vehiculo se queda en el ultimo, que es lo honesto con un dato lento.
//
// Logica pura: el reloj entra como argumento y el dibujo vive en el renderer.
/**
 * Salto a partir del cual el marcador se teletransporta en vez de deslizarse:
 * un auto que reaparece en otra planta no cruza la ciudad en pantalla.
 */
export const GLIDE_MAX_JUMP_M = 3_000;
/** Debajo de esto el movimiento es ruido de GPS: no cambia el rumbo. */
const HEADING_MIN_MOVE_M = 5;
const EARTH_RADIUS_M = 6_371_000;
const rad = (deg) => (deg * Math.PI) / 180;
/** Distancia sobre la esfera, en metros (haversine). */
export function distanceM(a, b) {
    const dLat = rad(b.lat - a.lat);
    const dLng = rad(b.lng - a.lng);
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
    return 2 * EARTH_RADIUS_M * Math.asin(Math.min(1, Math.sqrt(h)));
}
/** Rumbo inicial de a hacia b, en grados [0, 360). */
export function bearing(a, b) {
    const y = Math.sin(rad(b.lng - a.lng)) * Math.cos(rad(b.lat));
    const x = Math.cos(rad(a.lat)) * Math.sin(rad(b.lat)) - Math.sin(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.cos(rad(b.lng - a.lng));
    return ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360;
}
/** Posicion y rumbo a mostrar en `nowMs`. */
export function glideFrame(state, nowMs) {
    const t = state.durationMs <= 0 ? 1 : Math.min(1, Math.max(0, (nowMs - state.startMs) / state.durationMs));
    return {
        lat: state.from.lat + (state.to.lat - state.from.lat) * t,
        lng: state.from.lng + (state.to.lng - state.from.lng) * t,
        heading: state.heading,
    };
}
/**
 * Estado despues de un reporte. El primero planta el marcador; uno con el
 * mismo instante no cambia nada; uno nuevo arranca un deslizamiento desde lo
 * que se ve ahora (no desde el reporte anterior, asi no hay saltos hacia
 * atras si el anterior todavia no habia terminado).
 */
export function onGlideReport(previous, report, nowMs, durationMs) {
    const to = { lat: report.coordinates.lat, lng: report.coordinates.lng };
    if (previous === undefined)
        return { from: to, to, startMs: nowMs, durationMs: 0, heading: 0, instant: report.instant };
    if (previous.instant === report.instant)
        return previous;
    const shown = glideFrame(previous, nowMs);
    const from = { lat: shown.lat, lng: shown.lng };
    const moved = distanceM(from, to);
    const heading = moved < HEADING_MIN_MOVE_M ? previous.heading : bearing(from, to);
    if (moved > GLIDE_MAX_JUMP_M)
        return { from: to, to, startMs: nowMs, durationMs: 0, heading, instant: report.instant };
    return { from, to, startMs: nowMs, durationMs, heading, instant: report.instant };
}
//# sourceMappingURL=glide.js.map